import React from 'react';

export enum ScoringType {
  TIME = 'TIME',
  CALORIES = 'CALORIES',
  DISTANCE = 'DISTANCE',
  REPS = 'REPS',
  ROUNDS = 'ROUNDS',
  ROUNDS_REPS = 'ROUNDS_REPS',
  WEIGHT = 'WEIGHT',
}

export type WeightUnit = 'kg' | 'lbs';
export type DistanceUnit = 'm' | 'km' | 'mi';

export type TimeResult = { scoringType: ScoringType.TIME; minutes: number | ''; seconds: number | '' };
export type CaloriesResult = { scoringType: ScoringType.CALORIES; calories: number | '' };
export type DistanceResult = { scoringType: ScoringType.DISTANCE; value: number | ''; unit: DistanceUnit };
export type RepsResult = { scoringType: ScoringType.REPS; reps: number | '' };
export type RoundsResult = { scoringType: ScoringType.ROUNDS; rounds: number | '' };
export type RoundsRepsResult = {
  scoringType: ScoringType.ROUNDS_REPS;
  rounds: number | '';
  reps: number | '';
};
export type WeightSetEntry = { reps: number | ''; weight: number | ''; unit: WeightUnit };
export type WeightResult = { scoringType: ScoringType.WEIGHT; sets: WeightSetEntry[] };

export type MovementResult =
  | TimeResult
  | CaloriesResult
  | DistanceResult
  | RepsResult
  | RoundsResult
  | RoundsRepsResult
  | WeightResult;

const PASS_THROUGH_KEYS = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'];

export const blockNonInteger = (e: React.KeyboardEvent<HTMLInputElement>): void => {
  if (!/^\d$/.test(e.key) && !PASS_THROUGH_KEYS.includes(e.key) && !e.ctrlKey && !e.metaKey)
    e.preventDefault();
};

export const blockNonDecimal = (e: React.KeyboardEvent<HTMLInputElement>): void => {
  if (!/^[\d.]$/.test(e.key) && !PASS_THROUGH_KEYS.includes(e.key) && !e.ctrlKey && !e.metaKey)
    e.preventDefault();
};
